import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalLoaderService } from './../../_services/global-loader.service';

@Component({
  selector: 'global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {

  showLoader: boolean = false
  loaderUnsubcribe: any;
  constructor(
    private globalLoaderService: GlobalLoaderService
  ) { }

  ngOnInit(): void {
    this.loaderUnsubcribe = this.globalLoaderService.getLoaderState().subscribe(status => {
      this.showLoader = status;
    })
  }

  ngOnDestroy() {
  }

}
